const BASE_URL = "/inventory";


export default [
  {
    path: `${BASE_URL}`,
    name: "Inventory",
    component: () => import("@/pages/inventory/Index.vue"),
  },
  {
    path: `${BASE_URL}/item`,
    name: "Item",
    component: () => import("@/pages/inventory/item/Index.vue"),
  },
  {
    path: `${BASE_URL}/setup`,
    name: "Inventory Setup",
    component: () => import("@/pages/inventory/inventorySetup/Index.vue"),
  },
  {
    path: `${BASE_URL}/item-journal`,
    name: "Item Journal",
    component: () => import("@/pages/inventory/itemJournal/Index.vue"),
  },
  {
    path: `${BASE_URL}/item-ledgers`,
    name: "Item Ledger Info",
    component: () => import("@/pages/inventory/ledgers/Index.vue"),
  }, 
  {
    path: `${BASE_URL}/physical-inventory-journal`,
    name: "Physical Inventory Journal",
    component: () => import("@/pages/inventory/physicalInventoryJournal/Index.vue"),
  },
  {
    path: `${BASE_URL}/item-journal-master-template`,
    name: "Item Journal Master Template",
    component: () => import("@/pages/inventory/itemJournalMasterTemplate/Index.vue"),
  },
  {
    path: `${BASE_URL}/item-vendor-purchase-price`,
    name: "Item Vendor Purchase Price",
    component: () => import("@/modules/item_vendor_purchase_price/view/ItemVendorPurchasePricePage.vue"),
  },
];
